let nowClientWidth = document.documentElement.clientWidth;
window.nowSize = function(val, initWidth = 3840) {
    return val * (nowClientWidth / initWidth);
};


